import { render } from "./AdminProfile.vue?vue&type=template&id=c524e94c&ts=true"
import script from "./AdminProfile.vue?vue&type=script&lang=ts"
export * from "./AdminProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__